// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qrVH","title":"Header_title__-cbck","side":"Header_side__qzwA0"};